<template>
    <u-card-flat-rounded v-bind="$attrs">
        <template v-if="innerClass || cardInnerSize">
            <div class="card-inner" :class="[innerClass, cardInnerSize]">
                <slot />
            </div>
        </template>
        <template v-else>
            <slot />
        </template>
    </u-card-flat-rounded>
</template>

<script>
import UCardFlatRounded from "@/components/publish/styles/cards/u-card-flat-rounded.vue";

export default {
    props: {
        innerClass: { type: String, default: "" },
        cardInnerSize: { type: String, default: "" },
    },
    components: {
        UCardFlatRounded,
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
